import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {EmailService} from './email.service';

@Injectable({
  providedIn: 'root'
})
export class MemberTempService {

  public spinner: boolean;

  public objectImage: any;
  public storedImage: any;
  public storedImagePrevious: any;

  constructor (
    public db: AngularFirestore,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService,
    public _emailService: EmailService,
    private fs: AngularFireStorage,
  ) { }

  getTempDataById (id) {
    return this.db.doc<any>('sbccv_members_temp/' + id)
      .get();
  }

  createMemberForm (member) {

    if (member.image) {
      this.storedImage = member.image
    } else {
      this.storedImage = 'assets/images/geral/photoURL.png'
    }
    this.storedImagePrevious = this.storedImage

    return this.fb.group({
      id: new FormControl(member.id),
      name: new FormControl(member.name, [ Validators.required ]),
      email: new FormControl(member.email, [ Validators.required, Validators.email ]),
      cellPhone: new FormControl(member.cellPhone, [ Validators.required ]),
      text: new FormControl(member.text, [ Validators.required ]),
      image: new FormControl(member.image)
    });
  }

  undoImageChange () {
    this.objectImage = null
    this.storedImage = this.storedImagePrevious
  }

  insert (id: string, member: any) {
    this.db.collection('sbccv_members_temp').doc(id).set(Object.assign({}, member))
      .then(() => {console.log("insert member temp")})
      .catch(() => {console.log("error insert member temp")})
  }

  update (id: string, entity: any) {
    return this.db.collection('sbccv_members_temp').doc(id).set(Object.assign({}, entity), {'merge': true})
  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage (file, member_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/members_temp/" + member_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    return fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(result => {
          return result
        });
      }))

  }

  updateImage (member_id: any, url: any, updatedMember: any) {
    return this.db.collection('sbccv_members_temp').doc(member_id).set({'image': url, 'imageChanged': true}, {merge: true})
      .then(() => {
        this.storedImage = ""
        return url;
      })
      .catch((err) => {
        console.log("erro upadate member temp image: " + JSON.stringify(err))
      })
  }

  selectChanged () {
    return this.db.collection<any>('sbccv_members_temp', ref => ref
      .where('changed', '==', true)
      .where('updated', '==', true)
      .orderBy('name', 'asc')
    ).snapshotChanges();
  }

  moveToMember (changedMember) {

    let id = changedMember.id

    if (changedMember.text || changedMember.image) {
      //atualiza member e member_temp
      this.db.collection('sbccv_members').doc(id).set(Object.assign({}, changedMember), {'merge': true})
        .then(() => {
          this.update(id, {'moved': true, 'dateUpdated': new Date()})
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err) => {
              this.snackBar.openSnackBar("Erro!", '', 'error')
            })
        })
    } else {
      //atualiza apenas member_temp
      this.update(id, {'moved': true, 'dateUpdated': new Date()})
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success')
        })
        .catch((err) => {
          this.snackBar.openSnackBar("Erro!", '', 'error')
        })
    }
    

  }

  /*
  sendEmailMemberUpdated (updatedMember: any, image: string = null) {
    let html = ''
    html += '<div>'
    if (image) {
      html += '<p>' + image + '</p>'
    }
    html += '<p>' + updatedMember.name + '</p>'
    html += '<p>' + updatedMember.email + '</p>'
    html += '<p>' + updatedMember.cellPhone + '</p>'
    html += '<p>' + updatedMember.text + '</p>'

    html += '</div>'

    let mailOptions: any = {
      'subject': 'SBCCV Atualização: ' + updatedMember.name,
      'html': html,
      'from': 'SBCCV <cientifico@sbccv.org.br>',
      'to': 'sandra@sbccv.org.br', 
      'bcc': 'email.otero@gmail.com'
    }

    this._emailService.sendStandardEmail(mailOptions)
      .then(() => {
        console.log("email enviado")
        this._router.navigate([ 'invite_end' ]);
      })
      .catch(() => {
        console.log("erro ao enviar email 698")
      })
  }
  
  */

}
